// extracted by mini-css-extract-plugin
export var homepageFaqs = "HomepageFaqs--homepageFaqs--Rmlp-";
export var homepageFaqs__title = "HomepageFaqs--homepageFaqs__title--VX26z";
export var panel = "HomepageFaqs--panel--1IlN0";
export var tkMyriadProSemiCondensed = "HomepageFaqs--tk-myriad-pro-semi-condensed--QADX5";